// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'press.admin',
    path: 'S0801PressSetting/index',
    name: 'TTC PRESS Setting',
    component: () => import('./PgMainPage'),
    meta: {
      roles: ['SA', 'PA', 'VA', 'PAP', 'PAL', 'PAC', 'PAA']
    }
  }
]
